/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.PostPurchaseTrackingClaimSubmission = class PostPurchaseTrackingClaimSubmission {
  constructor(el, controller) {
    this.onFieldChange = this.onFieldChange.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.allFieldsValid = this.allFieldsValid.bind(this);
    this.customFieldValid = this.customFieldValid.bind(this);
    this.firstNameValid = this.firstNameValid.bind(this);
    this.lastNameValid = this.lastNameValid.bind(this);
    this._formSubmitted = this._formSubmitted.bind(this);
    this._setup = this._setup.bind(this);
    this.el = el;
    this.controller = controller;
    this.el.on('submit', this._formSubmitted);
    this.customField = this.el.find('[data-input="custom-field"]');
    this.submitButton = this.el.find('[data-button]');
    setTimeout(this._setup, 0);
    this.firstName = this.el.find('[data-input="first_name"]');
    this.lastName = this.el.find('[data-input="last_name"]');
  }

  onFieldChange(cb) {
    this.customField.on('input', cb);
    this.customField.on('change', 'input', cb);
    this.firstName.on('input', 'input', cb);
    return this.lastName.on('input', 'input', cb);
  }

  disableButton() {
    return this.submitButton.attr('disabled','disabled');
  }

  enableButton() {
    return this.submitButton.removeAttr('disabled');
  }

  allFieldsValid() {
    return this.customFieldValid() && this.firstNameValid() && this.lastNameValid();
  }

  redirectToFriendConfirmationPage() {
    return window.open(this.el.data('confirmation-url'),'_self');
  }

  customFieldValid() {
    const input = this.customField.find('input');
    return new Buyapowa.Helpers.CustomSignupFieldValidator(input).isValid();
  }

  firstNameValid() {
    const input = this.firstName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.PartialNameValidator(input.val()).isValid();
  }

  lastNameValid() {
    const input = this.lastName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.PartialNameValidator(input.val()).isValid();
  }

  getUrl() {
    return this.el.attr('action');
  }

  getData() {
    return this.el.serializeObject();
  }

  failureText() {
    return this.el.data('failure-text');
  }

  _formSubmitted(e) {
    this.controller.claimButtonClicked();

    e.preventDefault();
    return false;
  }

  _setup() {
    return this.controller.previouslySubmitted();
  }
};
